import i18n from '../../i18n/i18n';

export const MAX_AVATAR_BYTES = 2000000;

export const AVATAR_PICKER_OPTIONS = {
	maxWidth: 1024,
	maxHeight: 1024,
	quality: 0.7,
} as const;

const bytesToMb = (bytes: number) => (bytes / 1000000).toFixed(1);

export type PickedAsset = {
	uri?: string | null;
	fileName?: string | null;
	type?: string | null;
	fileSize?: number | null;
	width?: number | null;
	height?: number | null;
};

export const logPickedAsset = (asset: PickedAsset) => {
	const uri = asset.uri ?? '';
	const scheme = uri.includes(':') ? uri.slice(0, uri.indexOf(':')) : 'none';

	console.log(
		`[Avatar] picked scheme=${scheme} size=${asset.fileSize} type=${asset.type} ` +
			`dims=${asset.width ?? '?'}x${asset.height ?? '?'} name=${asset.fileName} uri=${uri}`,
	);
};

export const getAvatarSizeError = (bytes?: number | null): string | undefined => {
	if (typeof bytes !== 'number' || Number.isNaN(bytes) || bytes <= 0) return undefined;
	if (bytes <= MAX_AVATAR_BYTES) return undefined;

	return i18n.t('T_SITE_AVATAR_SIZE_ERROR', {
		defaultValue: 'This image is {{size}}MB. Please pick one under {{max}}MB.',
		size: bytesToMb(bytes),
		max: bytesToMb(MAX_AVATAR_BYTES),
	});
};

export const getAvatarUploadErrorMessage = (err: any): string => {
	const status = err?.response?.status;
	const serverMessage = err?.response?.data?.message;

	if (typeof serverMessage === 'string' && serverMessage) return serverMessage;
	if (Array.isArray(serverMessage) && serverMessage.length) return String(serverMessage[0]);

	if (status === 413 || status === 400) {
		return i18n.t('T_SITE_AVATAR_REJECTED', {
			defaultValue: 'Image rejected by the server. Please pick one under {{max}}MB.',
			max: bytesToMb(MAX_AVATAR_BYTES),
		});
	}

	if (!err?.response) {
		return i18n.t('T_SITE_NETWORK_UNREACHABLE', {
			defaultValue: 'Could not reach the server. Please check your connection.',
		});
	}

	return (
		err?.message || i18n.t('T_SITE_AVATAR_UPLOAD_FAILED', { defaultValue: 'Avatar upload failed' })
	);
};
